import axios from "axios";
import { fetchAccessToken } from "../common/Common";

//axios.defaults.headers.common["x-functions-key"] =
//  process.env.REACT_APP_AUTH_TOKEN || "";

export async function fetchGroupUsers(groupId: string, adminId: string) {
  let accessToken = await fetchAccessToken();
  groupId = groupId.replace('\r\n','');
  adminId = adminId.replace('\r\n','');
  axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
  
  if (validateId(adminId)) {
    // API : - ${process.env.REACT_APP_ENDPOINT}/api/v2/tesseract/admin/${adminId}/groups?groupName=${groupId}
    return axios(
      {
        method:'get',
        baseURL:process.env.REACT_APP_ENDPOINT,
        url : `/api/v2/tesseract/admin/${encodeURIComponent(adminId)}/groups`,
        params:{
          groupName: `${groupId}`
        }

      }
    )
  } else {
    return Promise.reject({
      status: 400,
      message: "Invalid request"
    })
  }
}

export async function searchUserByEmail(email: string) {
  let accessToken = await fetchAccessToken();
  const payload = {
    type: "EMAIL",
    data: [email],
  };
  axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
  return axios.post(
    `${process.env.REACT_APP_ENDPOINT}/api/v2/skfsso/findusers`,
    payload
  );
}
export async function attachUserToGroup(payload: {
  userProfileId: string;
  group: string;
}) {
  let accessToken = await fetchAccessToken();
  axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
  return axios.post(
    `${process.env.REACT_APP_ENDPOINT}/api/v1/upr/appsuite/groups`,
    payload
  );
}

export async function deattachUserFromGroup(payload: {
  userProfileId: string;
  group: string;
}) {
  let accessToken = await fetchAccessToken();
  axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
  return axios.post(
    `${process.env.REACT_APP_ENDPOINT}/api/v1/upr/appsuite/groups/detach`,
    payload
  );
}

const validateId = (id: string) => {
  const idRegex = /^[a-zA-Z0-9_-]+$/;
  return ((typeof id === "string") && (idRegex.test(id)))
}
